















































































import { Vue, Component, Watch, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import { TeamTokenInfo } from '@/api/tournament'
import ServerError from '@/utils/server_error'
import i18n from '@/lang'

export interface TokenAcceptPayload {
  token: string
  info: TeamTokenInfo
}

@Component
export default class EnterInvitationCode extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  teamToken: string = ''
  teamTokenRules: Function[] = [
    (v: any) => !!v || i18n.t('EnterInvitationCode.TeamCodeIsRequired'),
    (v: any) =>
      (v && v.replace(' ', '').length === 6) ||
      i18n.t('EnterInvitationCode.TheTeamCodeMustHave6Characters')
  ]
  tokenInfo: TeamTokenInfo | null = null
  loading: boolean = false
  errorMessage: string | null = null

  get teamTokenTrimmed() {
    return this.teamToken.replace(' ', '')
  }

  get selectedTournament() {
    return this.tournamentModule.selectedTournament
  }

  /* Watcher */
  @Watch('teamToken')
  onTeamTokenChanged(value: string) {
    value = value.replace(' ', '').toUpperCase()
    if (value.length > 3) {
      // value = `${value.substring(0, 3)} ${value.substring(3)}`
    }
    this.teamToken = value
  }

  reset() {
    this.teamToken = ''
    this.tokenInfo = null
    this.errorMessage = null
  }

  @Emit('confirmToken')
  confirmToken() {
    return {
      token: this.teamTokenTrimmed,
      info: this.tokenInfo
    } as TokenAcceptPayload
  }

  // this function is exposed
  async submitTeamToken(teamToken: string) {
    this.teamToken = teamToken
    await this.onSubmit()
  }

  async onSubmit() {
    this.loading = true
    this.errorMessage = null

    try {
      const tokenInfo = await this.tournamentModule.fetchTeamTokenInformation(
        this.teamTokenTrimmed
      )

      if (
        !this.tournamentModule.selectedTournament ||
        (this.tournamentModule.selectedTournament &&
          tokenInfo.tournamentId !==
            this.tournamentModule.selectedTournament!.tournamentId)
      ) {
        this.$toast.error(
          this.$t('EnterInvitationCode.InvitationCodeNotCorrespondToTournament')
        )
        setTimeout(async () => {
          await this.tournamentModule.setSelectedTournament(
            tokenInfo.tournamentId
          )
        }, 1000)
        return
      }

      this.tokenInfo = tokenInfo
    } catch (err) {
      if (err instanceof ServerError) {
        this.errorMessage = err.getMessage()
      } else {
        this.$toast.error(this.$t('EnterInvitationCode.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.loading = false
    }
  }
}
